// extracted by mini-css-extract-plugin
module.exports = {"image":"Image_style_image__Tdwk2","tag":"Image_style_tag__2vC0t"};